import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ComplianceRoutingModule } from './compliance-routing.module';
import { ComplianceComponent } from './compliance.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { DetailsComponent } from './details/details.component';
import { NewComponent } from './new/new.component';

@NgModule({
  declarations: [ComplianceComponent, DetailsComponent, NewComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    ComplianceRoutingModule
  ],
  exports: [ComplianceComponent],
})
export class ComplianceModule { }
